module.exports = __webpack_public_path__ + "img/20250919_0.48927809.jpg";